module.exports = __webpack_public_path__ + "7bb89a71b37e3cf4a76de4c1733d5bd5.svg";